export default __webpack_public_path__ + "static/media/27-get-personal.8284ed6e.jpg";